<style scoped lang="scss">

</style>

<template>
    <div class="uk-form" v-if="applicant">
        <div v-if="landlordUploadedFile" class="uk-grid">
            <div class="uk-width-1-1 uk-margin-large-bottom">
                <h2>Your landlord has uploaded your hardship request for you.</h2>
                <h4>You may view it below or click 'Done' to complete this application.</h4>
            </div>

            <div class="uk-width-1-1 preview uk-margin-large-bottom">
                <button @click="openPreview" class="uk-button uk-button-large">View Hardship Document</button>
                <preview-documents-modal ref="previewModal"></preview-documents-modal>
            </div>
        </div>
        <div class="uk-grid" v-else>

            <div class="uk-width-1-1 uk-margin-bottom uk-block uk-block-default">
                <p>
                    I, {{ applicant.first_name }} {{ applicant.last_name }}, am a tenant at
                    {{ addressString }}. I am unable to pay my obligations under the rental agreement because of one or more of the reasons below that have impacted me since March 16, 2020:
                </p>
                <ul>
                    <li>Loss of household income;</li>
                    <li>Increased medical expenses;</li>
                    <li>Loss of work or wages;</li>
                    <li>Increased childcare responsibilities or responsibilities to care for a person with a disability or a person who is elderly, injured or sick;</li>
                    <li>Increased costs for childcare or caring for a person with a disability or a person who is elderly, injured, or sick; or</li>
                    <li>Other circumstances that have reduced my income or increased my expenses.</li>
                </ul>
            </div>

            <div class="uk-width-1-1">
                <p>Any public assistance, including unemployment insurance, pandemic unemployment assistance and other public assistance that I have received on or after March 16, 2020, does not fully make up for my loss of income or increased expenses.</p>
                <p>I understand that I still owe my rent, which must be paid by July 1, 2021.</p>
                <p>I understand that I must comply with other obligations that I may have under my rental agreement.</p>
                <p>I hereby declare that the above statement is true to the best of my knowledge and belief, and that I understand it may be used as evidence in court and is subject to penalty for perjury.</p>
            </div>

            <div class="uk-width-1-1 uk-margin-large-top">
                <div class="uk-grid" v-if="application.household">
                    <div class="uk-width-small-1-1 uk-width-medium-1-1 uk-width-large-1-2" v-for="member in application.household.members">

                            <validated-section :errors="errors" :field="'signature_'+member.id">
                                <signature-box @updated="onSignatureUpdated"
                                               :user-key="member.id"
                                               :is-signed="signatureData[member.id] && signatureData[member.id].affidavit_signed_at !== null"
                                               :completed="signatureData[member.id] && signatureData[member.id].completed"
                                               :name="member.first_name + ' ' + member.last_name"></signature-box>
                            </validated-section>

                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import ValidatedSection from "../../../../../components/Common/ValidatedSection";
    import SignatureBox from "../../../../../components/AppWizard/SignatureBox";
    import PreviewDocumentsModal from "../../../../../../dashboard/pages/Documents/PreviewDocumentModal";

    export default {
        name: "OregonDeclarationOfHardship",
        components: {PreviewDocumentsModal, SignatureBox, ValidatedSection},
        data() {
            return {
                signatureData: {},
                errors: {},
            }
        },
        computed: {
            addressString() {
                let string = '';

                if(this.applicant.property_address.line_1) {
                    string += this.applicant.property_address.line_1;

                    string += ', ' + this.applicant.property_address.city;

                    string += ', ' + this.applicant.property_address.state;

                    string += ' ' + this.applicant.property_address.zip;
                }

                return string;
            },

            document() {
                let document = null;

                _.each(this.documents, doc => {
                    _.each(doc.categories, cat => {
                        if(cat.key === 'hardship-document') {
                            document = doc;
                        }
                    })
                })

                return document;
            },

            landlordUploadedFile() {
                return this.document !== null && this.user !== null && this.document.user_id !== this.user.id;
            },
            ...mapState('Application', {
                application: state => state.application,
                applicant: state => state.applicant,
                documents: state => state.documents,
                documentRequests: state => state.documentRequests,
            }),
            ...mapState('App', {
                user: state => state.user,
            }),
        },
        watch: {
            application(newValue) {
                if(newValue.household) {
                    this.initData();
                }
            }
        },
        mounted() {
            if(this.application) this.initData();
        },
        methods: {
            openPreview() {
                if(this.document) {
                    let url = `/api/hope/application/${this.application.id}/documents/${this.document.id}/preview`;
                    console.log(this.$refs);
                    this.$refs.previewModal.open(url, this.document);
                }
            },
            initData() {
                _.each(this.application.household.members, member => {
                    const signatureFiltered = this.signatures.find(item => item.key === `app-step-4`)
                    if(signatureFiltered) {
                        this.$set(this.signatureData, member.id, { affidavit_signed_at: member.affidavit_signed_at, completed: true });
                    }

                })
            },
            onSignatureUpdated($event) {
                if(!this.signatures[$event.key]) {
                    this.$set(this.signatureData, $event.key, {});
                }
                this.$set(this.signatureData[$event.key], 'affidavit_signed_at', $event.isSigned ? moment().format('YYYY-MM-DD HH:mm') : null);
            },
            async validateStep() {

                this.errors = {};
                // Local Validation
                for(var i in this.application.household.members) {
                    let member = this.application.household.members[i];
                    if(member.age >= 18) {
                        if(!this.signatureData[member.id]) {
                            this.errors['signature_'+member.id] = {
                                errors: [member.first_name + ' ' + member.last_name + ' must sign this form as their name appears above.'],
                            };
                        }else if(this.signatureData[member.id] && this.signatureData[member.id].affidavit_signed_at == null) {
                            this.errors['signature_'+member.id] = {
                                errors: [member.first_name + ' ' + member.last_name + ' must sign this form as their name appears above.'],
                            };
                        }
                    }
                }

                let errorCount = _.size(this.errors);

                if(errorCount > 0) return false;

                // Server Side Validation
                try {
                    let response = await this.save();
                    await this.$store.dispatch('Application/fetch', this.application.id);
                    return true;
                }catch(err) {
                    console.error(err);
                }
            },
            save() {
                let data = {
                    signatures: this.signatureData,
                }
                return axios.put(`/api/hope/applications/${this.application.id}/step-4`, data);
            }
        },
    }
</script>
